import React, { useState, useMemo, useEffect } from "react";
import { useForm } from "react-hook-form";

import devuelveDependenciaConstultada from "../tools/devuelveDependencia";
import devuelveSede from "../tools/devuelveSede";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";

const SelectorDestino = ({ onChange }) => {
  const Usuario = ObtieneDatosCookies();

  const { register, watch, setValue } = useForm({
    defaultValues: {
      sedeID: Usuario?.sedeID ? String(Usuario.sedeID) : "",
      destino: "",
    },
  });

  const [busqueda, setBusqueda] = useState("");

  const destinos = devuelveDependenciaConstultada();
  const sedes = devuelveSede();

  const sedeSeleccionada = watch("sedeID");
  const destinoSeleccionado = watch("destino");

  // =====================================================
  // DESTINO 45 SOLO PUEDE UTILIZAR SEDE 1
  // =====================================================
  const destinoSoloSedeProvincial =
    String(destinoSeleccionado) == "21";

  const nombreSede = (id) => {
    const mapaSedes = {
      1: "Provincial",
      2: "Rosario",
      3: "Recreo",
      4: "Reconquista",
    };

    return mapaSedes[Number(id)] || "Sin sede";
  };

  const sedeFinal =
    sedeSeleccionada ||
    (Usuario?.sedeID ? String(Usuario.sedeID) : "");

  // =====================================================
  // SEDES
  // =====================================================
  const sedesFiltradas = useMemo(() => {
    return sedes.filter(
      (s) => s.id != 6 && s.id != 5
    );
  }, [sedes]);

  // =====================================================
  // DESTINOS
  // =====================================================
  const destinosFiltrados = useMemo(() => {
    return destinos
      .filter(
        (d) =>
          d.id != 37 &&
          d.id != 41 &&
          d.id != 30 &&
          d.id != 31 &&
          d.id != 32 &&
          d.id != 33 &&
          d.id != 35 &&
                    d.id != 45 &&
          d.id != 36
      )
      .filter((d) =>
        d.descripcion
          .toLowerCase()
          .includes(busqueda.toLowerCase())
      );
  }, [busqueda, destinos]);

  // =====================================================
  // CARGAR SEDE DEL USUARIO
  // =====================================================
  useEffect(() => {
    if (Usuario?.sedeID && !destinoSoloSedeProvincial) {
      setValue("sedeID", String(Usuario.sedeID), {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  }, [
    Usuario?.sedeID,
    setValue,
    destinoSoloSedeProvincial,
  ]);

  // =====================================================
  // SI DESTINO ES 45 -> FORZAR SEDE 1
  // =====================================================
  useEffect(() => {
    if (destinoSoloSedeProvincial) {
      setValue("sedeID", "1", {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  }, [
    destinoSoloSedeProvincial,
    setValue,
  ]);

  // =====================================================
  // INFORMAR CAMBIOS AL PADRE
  // =====================================================
  useEffect(() => {
    if (onChange) {
      onChange({
        sedeID: sedeFinal,
        destino: destinoSeleccionado,
      });
    }
  }, [
    sedeFinal,
    destinoSeleccionado,
    onChange,
  ]);

  // =====================================================
  // SELECCIONAR DESTINO
  // =====================================================
  const seleccionarDestino = (destino) => {
    const destinoId = String(destino.id);

    setValue("destino", destinoId, {
      shouldValidate: true,
      shouldDirty: true,
    });

    // DESTINO 45 -> SEDE 1 OBLIGATORIA
    if (destinoId == "21") {
      setValue("sedeID", "1", {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  return (
    <>
      {/* =====================================================
          SEDE
      ===================================================== */}
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <label className="input-group-text">
            Sede de Destino
          </label>
        </div>

        <select
          className="custom-select"
          {...register("sedeID", {
            required: true,
          })}
          disabled={destinoSoloSedeProvincial}
        >
          <option value="">
            Seleccione...
          </option>

          {sedesFiltradas.map((s) => (
            <option
              key={s.id}
              value={s.id}
            >
              SEDE {s.id} - {nombreSede(s.id)}
            </option>
          ))}
        </select>
      </div>

      {/* AVISO DESTINO 45 */}
      {destinoSoloSedeProvincial && (
        <div
          className="alert alert-info py-2 mb-3"
          role="alert"
        >
          Este destino corresponde únicamente a la
          <strong> Sede Provincial</strong>.
        </div>
      )}

      {/* =====================================================
          BUSCADOR
      ===================================================== */}
      <input
        type="text"
        className="form-control mb-2"
        placeholder="Buscar destino..."
        value={busqueda}
        onChange={(e) =>
          setBusqueda(e.target.value)
        }
      />

      {/* =====================================================
          DESTINOS
      ===================================================== */}
      <div
        style={{
          maxHeight: "200px",
          overflowY: "auto",
          border: "1px solid #ccc",
          borderRadius: "5px",
        }}
      >
        {destinosFiltrados.map((d) => (
          <div
            key={d.id}
            onClick={() =>
              seleccionarDestino(d)
            }
            style={{
              padding: "8px",
              cursor: "pointer",

              background:
                String(destinoSeleccionado) ===
                String(d.id)
                  ? "#007bff"
                  : "white",

              color:
                String(destinoSeleccionado) ===
                String(d.id)
                  ? "white"
                  : "black",

              transition: "all .15s",
            }}
          >
            {d.descripcion}

            {String(d.id) == "21" && (
              <small
                style={{
                  marginLeft: "8px",
                  opacity: 0.8,
                }}
              >
                (Solo Sede Provincial)
              </small>
            )}
          </div>
        ))}

        {destinosFiltrados.length === 0 && (
          <div
            style={{
              padding: "8px",
              color: "#999",
            }}
          >
            Sin resultados
          </div>
        )}
      </div>
    </>
  );
};

export default SelectorDestino;